<app-index-navbar></app-index-navbar>

<div class="container px-4 mx-auto" style="margin-top:100px; ">
    <div class="flex flex-wrap">
        <div class="w-full px-4 flex-1">
            <span class="block my-4 p-3 rounded border border-solid border-blueGray-100">

                <div class="container relative">
                    <h1 class="flex items-center flex-wrap font-mono md:text-xl mb-3">
                        <div>
                            <a [routerLink]="['/service']"
                                class="leading-relaxed inline-block mr-4 py-2 whitespace-nowrap"
                                style="color: rgb(153, 153, 153);">
                                Servicios >
                            </a>{{serviceDetails.name}}
                        </div>
                    </h1>

                    <div class="flex flex-wrap mb-5 ">
                        <a class="tag tag-white " tag-id="fill-mask">
                            <div class="tag-ico">
                                <app-svg-selector [name]=serviceDetails.strTaskType().en></app-svg-selector>
                            </div>
                            <span>{{serviceDetails.strTaskType().es}}</span>
                        </a>
                    </div>

                </div>

                <markdown [data]="serviceDetails.longDescription"></markdown>

                <p></p>
                <h2 class="relative group flex items-center">
                    Veamos cómo podemos usar el servicio
                </h2>
                <p>
                    A continuación mostramos como invocar el servicio usando cURL.
                </p>

                <p></p>
                <pre><code [highlight]="serviceDetails.codeSample"  [lineNumbers]="true"></code></pre>
                <p></p>

            </span>
        </div>

        <!-- <iframe src="https://43943.gradio.app/" title="W3Schools Free Online Web Tutorials"
  width="100%" height="100%"></iframe> -->

        <!-- <div class="w-8/12 px-4">
            <app-service-stats-and-test [serviceDetails]='serviceDetails'></app-service-stats-and-test>
        </div> -->
    </div>
</div>
